import React from 'react';
import PropTypes from 'prop-types';

// @material-ui
import {
  Button,
  Grid
} from '@material-ui/core';

// core
import { withLang } from '_core/hocs/withLang';
import { useCartContext } from '_core/contexts/Cart';
import AddressInput from '_core/components/AddressInputNew';
import { DeliveryWarehouseSelect } from '_core/components/DeliveryWarehouseSelect';

import { useStyle } from './style';


const RawProfileDeliveryInfoForm = (props) => {
  const { onClose, getLangString: l } = props;
  
  
  const classes = useStyle();
  
  const cart = useCartContext();
  
  
  return (
    <Grid container>
      <Grid item xs={12}>
        <AddressInput
          variant="delivery"
          type="city"
          label={l('global.field.city')}
          helperText=""
          determineAddress={false}
          selectedItem={cart.cityData}
          onSelectItem={(data) => cart.setCityData({ ...data, isConfirmed: true })}
        />
      </Grid>
      
      <DeliveryWarehouseSelect />
      
      <Grid item xs={12} className={classes.marginTop}>
        <Button
          onClick={onClose}
          className={classes.button}
        >
          {l('global.buttons.done')}
        </Button>
      </Grid>
    </Grid>
  );
};

RawProfileDeliveryInfoForm.defaultProps = {};

RawProfileDeliveryInfoForm.propTypes = {
  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
};

export const ProfileDeliveryInfoForm = withLang(RawProfileDeliveryInfoForm);

ProfileDeliveryInfoForm.getVisibility = (props) => {
  const { config } = props;
  
  return 'visible';
};
